import Vue from "vue";
import ModalDialog from "@/components/commons/modal-dialog";

let confirmationInstance = null;

const initialData = () => ({
    message: "",
    title: "",
    resolvePromise: null,
    rejectPromise: null,
    isOpen: false,
    preConfirm: null,
    isLoading: false,
    props: {},
    acceptHtml: false
});

const createConfirmationDialog = () => {
    const wrapper = document.createElement("div");
    document.body.appendChild(wrapper);

    const ModalConstructor = Vue.extend({
        name: "ConfirmationDialog",
        components: {
            ModalDialog
        },
        data() {
            return initialData();
        },
        methods: {
            async handle(isConfirm) {
                if (!this.isOpen) {
                    this.rejectPromise("Modal is not open");
                    return;
                }

                this.isLoading = true;
                this.isOpen = false;

                if (isConfirm) {
                    if (
                        this.preConfirm &&
                        typeof this.preConfirm === "function"
                    ) {
                        await this.preConfirm();
                    }

                    // skip emit to prevent @close event to be emitted causing the isConfirm to be set to false
                    this.$refs.modal.close({ skipEmit: true });
                }

                this.resolvePromise(isConfirm);

                this.reset();
            },
            reset() {
                Object.assign(this, initialData());
            },
            show(message, title, preConfirm, props = {}, acceptHtml) {
                this.message = message;
                this.title = title;
                this.isOpen = true;
                this.preConfirm = preConfirm;
                this.props = props;
                this.acceptHtml = acceptHtml;
                this.$refs.modal.open();

                return new Promise((resolve, reject) => {
                    this.resolvePromise = resolve;
                    this.rejectPromise = reject;
                });
            }
        },
        render(h) {
            return h("modal-dialog", {
                attrs: {
                    id: "vet-confirmation-dialog"
                },
                ref: "modal",
                props: Object.assign({}, this.props, {
                    isLoading: this.isLoading
                }),
                on: {
                    "confirm-dialog": () => this.handle(true),
                    close: () => this.handle(false)
                },
                scopedSlots: {
                    title: () => this.title,
                    body: () =>
                        this.acceptHtml
                            ? [
                                  h("span", {
                                      domProps: {
                                          innerHTML: this.message
                                      }
                                  })
                              ]
                            : this.message
                }
            });
        }
    });

    const instance = new ModalConstructor();
    instance.$mount(wrapper);
    return instance;
};

const confirmation = ({
    message = "Are you sure?",
    title = "Confirmation",
    preConfirm = null,
    props = {},
    acceptHtml = false
}) => {
    if (!confirmationInstance) {
        confirmationInstance = createConfirmationDialog();
    }
    return confirmationInstance.show(
        message,
        title,
        preConfirm,
        props,
        acceptHtml
    );
};

export default {
    install(Vue) {
        Vue.prototype.$confirmation = confirmation;
    }
};

export { confirmation };
